export default "__VITE_ASSET__668b0b70__"